import { useStore } from "@nanostores/react";

import {
  currenTrackDuration,
  currentTrackProgress,
  currentTrackTime,
} from "@/stores/player/playerStore";

import { formatTime } from "@/lib/public-profile";

import { ProgressBar } from "@/components/shared/progress/ProgressBar";
import Paragraph from "@/components/shared//text/paragraph";

export const PlayerTrackProgress = () => {
  const $currentTrackProgress = useStore(currentTrackProgress);
  const $currentTrackTime = useStore(currentTrackTime);
  const $currenTrackDuration = useStore(currenTrackDuration);

  const formattedTime = formatTime($currentTrackTime);
  const formattedDuration = formatTime($currenTrackDuration);

  return (
    <div className="flex w-full items-center gap-x-2">
      <Paragraph size="sm" className="text-white ease-in-out">
        {formattedTime}
      </Paragraph>
      <div className="m-auto w-full items-center justify-center">
        <ProgressBar
          progress={$currentTrackProgress}
          className="w-full rounded-full"
        />
      </div>
      <Paragraph size="sm" className="text-white ease-in-out">
        {formattedDuration}
      </Paragraph>
    </div>
  );
};
